<!-- 51Talk -->
<template>
<div>
  <h2 style="text-align:center">99%的妈妈都不知道的少儿英语启蒙</h2>
  <p style="text-align:center;color:gray;font-size:10pt"><span style="color:blue">51Talk青少服务号</span></p>
  <img class="__bg_gif " data-ratio="0.176" data-src="../../../static/images/51talk_bak.gif" data-type="gif" data-w="750" style="white-space: normal; visibility: visible !important; width: auto !important; height: auto !important;"
    _width="auto" src="../../../static/images/51talk_bak.gif" data-order="0" data-fail="0">
  <!-- <p style="text-align:center; color: red;">&nbsp;*****</p> -->
  <p><strong >请注意, 本文信息量5200字, 阅读时长约20-30分钟</strong></p>
  <p>
    读完本文，您可以刷新以下几点认知：
    <ol>
      <li>两岁以下的孩子看视频，听音频无效，只能跟大人在互动中学语言</li>
      <li>二语习得的“i+1”原则和心理学的“最近发展区理论”都表明不理解的磨耳朵都是无效的输入，而孩子的学习台阶越小越高效</li>
      <li>交流互动的启蒙方式最有效！但什么样的情况下的互动才是最高效呢？</li>
      <li>外教班一个学期只能教授100-200词汇，而这些您在家里都可以完成</li>
      <li>要想孩子的英语好，必须还是得靠家长的帮助</li>
    </ol>
    <span style="color:#3f3f3f;font-size: 12px;color: #888888;">-------------------------------------------------------------------------------</span>
  </p>

  <section class="" data-tools="135编辑器" data-id="91660" style="font-size: 16px;border-width: 0px;border-style: none;border-color: initial;box-sizing: border-box;" data-color="rgb(0, 180, 238)">
    <section data-role="paragraph" class="" style="border-width: 0px;border-style: none;border-color: initial;box-sizing: border-box;" data-color="rgb(255, 232, 0)">
      <section style="padding: 10px;box-sizing: border-box;">
        <section style="width: 100%;" data-width="100%">
          <section style="width: 36px;height: 36px;margin-right: auto;margin-left: auto;background-color: rgb(107, 107, 107);border-width: 1px;border-style: solid;border-color: transparent;box-sizing: border-box;">
            <section style="width: 0px;height: 0px;border-width: 5px 4px;border-style: solid;border-color: transparent transparent rgb(107, 107, 107) rgb(107, 107, 107);float: right;margin-right: -8px;margin-top: -2px;box-sizing: border-box;"></section>
            <section style="width: 36px;height: 36px;border-width: 2px;border-style: solid;border-color: rgb(107, 107, 107);background-color: rgb(255, 232, 0);margin-top: 8px;margin-left: 8px;text-align: center;font-size: 20px;color: rgb(255, 255, 255);font-weight: 600;line-height: 36px;overflow: hidden;box-sizing: border-box;">
              <p class="" data-brushtype="text" data-original-title="" title=""></p>
            </section>
            <section style="width: 0px;height: 0px;border-width: 5px;border-style: solid;border-color: rgb(107, 107, 107) rgb(107, 107, 107) transparent transparent;margin-top: -10px;margin-left: -1px;box-sizing: border-box;"></section>
          </section>
        </section>
      </section>
    </section>
  </section>

  <h3 style="text-align:center">No1 看动画片就能启蒙？</h3>
  <p>中国的课内英语教学，常被批评为“费时低效”。而亲子英语的各种操作方法中，如果我们从学术的角度来看，也存在着低效，甚至是无效的问题。我们知道，孩子从出生到6个月这半年里，都是世界公民，婴儿能够分辨出这世界上六千多种语言中包含的所有的音——大概有150个音吧。英语里只有44个音。然而，在6个月之后，婴儿转向只注意他周围经常听到的那个语言的发音，渐渐失去了分辨其他语言里的音的能力。这是人类大脑的一个修剪功能，没有用的，大脑就不要了。知道这个事情后，有些家长就想啊，给孩子从0岁起，播着英语的儿歌，这样孩子不就对这个声音不陌生，不会失去辨别能力了吗？这么做有没有效果呢？语言学家通过大量的实验得出了结论：<strong>两岁以下的孩子看视频，听音频无效，而且看电视有害</strong>,其中包含了以下两个著名的实验：</p>
  <section style="height: 25px;box-sizing: border-box;color: inherit;">
    <section style="height: 100%;width: 50px;float: left;border-top-width: 2px;border-top-style: solid;border-color: rgb(0, 180, 238);border-left-width: 2px;border-left-style: solid;box-sizing: border-box;color: inherit;"></section>
    <section style="display: inline-block;color: rgb(0, 180, 238);clear: both;box-sizing: border-box;border-color: rgb(172, 29, 16);"></section>
  </section>
  <p><strong style="color: black">婴儿互动 VS 看语音视频 VS 听音频(2003年)</strong>
    <blockquote>
      Kuhl教授把一些9个月大的美国婴儿分成两组，一组让9个月的美国婴儿4周里上12次中文课，每次25分钟，让一个讲汉语的母语人士和他们互动说话，另一组是对照组只讲英语。所以选择9个月的婴儿，是因为这时期的婴儿正处于失去对非母语音素敏感的过程中。另一对照组的美国婴儿，也用同样的时间和同样的方法，上同样内容的课，但是上的语言是英文。经过12次以后，发现上中文课的婴儿对中文音素的辨别能力能够恢复，甚至达到在中文为母语家庭中成长婴儿的水平；而另一对照组的婴儿，辨别中文音素的能力则没有得到改善。接下来在第二期的实验中，他们让一组婴儿看汉语的录像，一组婴儿听汉语录音。实验结果是视频和音频这两种方式都没用，婴儿辨别汉语发音的能力跟对照组没有区别
    </blockquote>
  </p>
  <p><strong style="color: black">婴儿交谈 VS 让婴儿只看录像(2014年)</strong></p>
  <p>
    <blockquote>
      语言学家把一两岁的幼儿分成两组，一组看一个真人通过skype跟他们交谈；一组播放录像。两组幼儿都尝试和屏幕上的人沟通，当然只有那组实时对话的成年人能够对孩子们的问题、表情等做出正确的反应。录像里的人虽然摆出和孩子们沟通的样子，但是由于是事前录好的，并不能有及时反应和调整。事后语言学家检验两组孩子是否学到了该成年人所用的一个词汇。结果是只有实时对话的那组学会了
    </blockquote>
    <section style="height: 25px;box-sizing: border-box;color: inherit;">
      <section style="height: 100%;width: 50px;float: right;border-bottom-width: 2px;border-bottom-style: solid;border-color: rgb(0, 180, 238);border-right-width: 2px;border-right-style: solid;box-sizing: border-box;color: inherit;"></section>
    </section>
  </p>

  <p>
    Kuhl的实验还支持了这样的观点，学习第二语言，希望达到母语水平，是经验期待性学习（Experience－expectant Learning）。实现这种学习需要两个基本条件：一个是神经系统的发育为这种学习提供了可能实现的机会；另一方面，能为幼儿提供合适的环境刺激，包括社会情绪的环境。这种环境的刺激在合适的时机里出现，才会实现这种学习过程，达到预想的目的。这实际上就包含了关键期的思想
  </p>

  <p>
    这样的实验还有很多，结论互相印证。从而我们知道了：<strong>两岁以下的儿童只能和大活人在互动中学语言</strong>。音频和视频对孩子的语言学习起不了作用，孩子学不到任何语音、词汇和语法，这意味着什么呢？这意味着给两岁以下儿童磨耳朵，是白磨，孩子不会从背景音乐式的音频里学到语音和词汇，外语是启蒙不了的，但也不是一无是处哈，也许音乐启蒙了呢。看电视更不行，两岁以下的儿童看视频是看不懂的。直到两岁以后，儿童才能意识到，电视中那个二维世界里的东西，是和现实中三维世界里的东西是一回事。两岁半到三岁以后，儿童才能从幼儿教育节目中学到些东西，包括词汇。
  </p>

  <p>
    研究表明，<strong>幼儿看电视的时间越长，说话越晚，语言能力发展越慢</strong>。这主要是因为看电视减少了儿童与成人的互动时间，而儿童和大人的互动才是他们学语言的方式, 此外，看电视对儿童的注意力和记忆力也有害，美国儿科协会呼吁两岁以下儿童不看电视。所以，家长们要用动画片给孩子进行应用启蒙，应在两岁半以后开始，最好在三岁开始。这意味着，两岁以前如果想启蒙，您只能自己上了。对于这个年龄段的儿童，最适合启蒙的是双语家庭，爸爸和妈妈各说一种母语的那种。如果您的口音不标准，最好还是不要教，因为这个年龄段启蒙最大的优势是语音，如果语音不好则没有价值了,但是如果可以用原汁原味的语音替代，自己给孩子讲解，重点帮助孩子指认。等到三岁可以有音频视频的输入方式了，再开始也不算不迟。据我观察，3-5岁启蒙的中国孩子英语语音都相当地道，并没有损失什么。
  </p>

  <section class="" data-tools="135编辑器" data-id="91660" style="font-size: 16px;border-width: 0px;border-style: none;border-color: initial;box-sizing: border-box;" data-color="rgb(255, 232, 0)">
    <section data-role="paragraph" class="" style="border-width: 0px;border-style: none;border-color: initial;box-sizing: border-box;" data-color="rgb(255, 232, 0)">
      <section style="padding: 10px;box-sizing: border-box;">
        <section style="width: 100%;" data-width="100%">
          <section style="width: 36px;height: 36px;margin-right: auto;margin-left: auto;background-color: rgb(107, 107, 107);border-width: 1px;border-style: solid;border-color: transparent;box-sizing: border-box;">
            <section style="width: 0px;height: 0px;border-width: 5px 4px;border-style: solid;border-color: transparent transparent rgb(107, 107, 107) rgb(107, 107, 107);float: right;margin-right: -8px;margin-top: -2px;box-sizing: border-box;"></section>
            <section style="width: 36px;height: 36px;border-width: 2px;border-style: solid;border-color: rgb(107, 107, 107);background-color: rgb(255, 232, 0);margin-top: 8px;margin-left: 8px;text-align: center;font-size: 20px;color: rgb(255, 255, 255);font-weight: 600;line-height: 36px;overflow: hidden;box-sizing: border-box;">
              <p class="" data-brushtype="text" data-original-title="" title=""></p>
            </section>
            <section style="width: 0px;height: 0px;border-width: 5px;border-style: solid;border-color: rgb(107, 107, 107) rgb(107, 107, 107) transparent transparent;margin-top: -10px;margin-left: -1px;box-sizing: border-box;"></section>
          </section>
        </section>
      </section>
    </section>
  </section>
  <h3 style="text-align:center">No2 不理解的输入是无效输入</h3>

  <p>
    我们孩子妈都爱看韩剧，如果想体会一下孩子的无效输入，那么很容易，把字幕关了，看能不能通过看一部韩剧学会点韩语。我想大家都会同意，没字幕看不懂不理解的话，听多少遍也学不会。同样，听韩语歌如果不看翻译不理解，也学不会韩语。不理解的声音就是噪音，大脑无法吸收无意义的东西。因此，不理解的输入，是无效输入。关于理解和语言学习的关系，让我们看看三个重要的理论。
  </p>
  <p>
    第一个是<strong>二语习得论里的可理解性输入</strong>。字母I代表学习者现有的水平，现在所处的位置。学习发生在什么地方呢？发生在I 加上一个1的地方。也就是说，在学习者原有的水平上，只加上一点点的新知，而且，这一点新知还得是可理解的
    <img data-w="" data-ratio="0.5625" title="I+1理解" src="../../../static/images/iplus1_understand.jpg">
  </p>

  <p>
    第二个理论是<strong>心理学的最近发展区</strong>。最里面的圆代表学习者现在已有的知识。中间的圆，代表在师长的帮助下能学到的知识。最外圈的圆代表太难的东西，学习者还暂时学不会。学习发生在什么地方？——发生在“最近发展区”，也就是中间那个圆。学习者要通过在最近发展区的、有外力帮助的学习，不断扩大自己的内圆，来取得进步
    <img data-w="" data-ratio="0.5625" title="最近发展区理论" src="../../../static/images/proximal.jpeg">
  </p>

  <p>
    第三个理论是<strong>教育学里的“搭脚手架”</strong>。这个理论是说，教师要动用一切手段，为学生提供帮助理解的讲解，在学生原有的知识技能和要学习的新知之间的距离处，搭脚手架供学生攀爬
    <img data-w="" data-ratio="0.5625" title="搭脚手架" src="../../../static/images/dajiao_education.jpg">
  </p>

  <p>
    我们不难看出，无论语言学、心理学还是教育学，这三个通行理论都讲了差不多的意思。我们家长能从中学到什么呢？首先是不理解的磨耳朵白磨。其次，在孩子学习语言的过程中，您的解释和帮助是必须的。如果动画片的语言太难，那么，大多数的语言是属于最近发展区之外的，孩子无法掌握。而在最近发展区内，家长又不提供必要的帮助的话，让孩子自己猜、琢磨、悟，最近发展区这个圆就扩大得很慢，是低效的。其实每个孩子都是以主题对世界进行探索，而内部是一个椭圆还是一个多边形都体现着孩子的知识图谱，我们作为家长需要做的就是发现孩子的兴趣图谱，帮助他们更好地成长。
  </p>

  <p>
    有的家长认为，有的动画片一开始孩子只能看懂20%，不要紧，多看几遍。看10遍就能懂40%了，看20遍就能懂80%了。首先，这样做能不能真正的懂80%还要打问号，其次，即使这种观点成立，看那么多遍，费那么多时间，也是十分低效的。为什么不让孩子看难度合适的动画片，一次就看懂，然后循序渐进呢？
  </p>

  <p>
    有的家长认为，儿童动画片里情境多，孩子会通过把情境和语言相对应来习得语言——即“情境对应”。然而，这样理想的、有大量情境的动画片是不多的。在很多情况下，情境不足以让孩子知道语言的准确意思。举个例子，假比方说孩子看到动画片里的猫拦住了老鼠，威风凛凛地说了一句话。那孩子如何能知道，猫说的到底是“站住！”还是“往哪儿跑！”还是“你服不服？”孩子能够看到动作，体会到说话人的情绪，甚至能借助画面里大致明白整个故事，但具体到每句话，还是糊里糊涂，没有甚解。如果孩子习惯于囫囵吞枣式的看动画片，满足于差不离就行，那么他的知识内圆就是充满漏洞的，在不牢固的基础上扩大出的最近发展区也是不牢靠的，虚假繁荣。论坛上有家长说初中孩子能读哈利波特了，可是考试成绩还不如同学，应试不行。这种能力的偏差让人觉得很不可思议。究其原因，也许是这种不求甚解造成的。我们讨论儿童的学习效率问题，还要遵循儿童习得语言的特点。
  </p>

  <p>
    儿童在习得语言时，和成年人相比，有什么特点和优势呢？
    <ul>
      <li>第一，<strong>儿童每次只处理很少的信息</strong>。他们只关心自己眼前的那点小事，吃喝拉撒睡还有玩。其余的语言都自动屏蔽，觉得都无关紧要，他们不care。正因为这个特点——只关注当前有关的很少的语言，不受干扰，儿童的学习很有效率，学了就会。慢慢积累就持续进步。语言学家管这种方法叫“少即是多”（less is more）</li>
      <li>第二、和儿童说话的大人都会自动调整语速、语言难度、发音清晰度，以方便儿童理解，并随时准备解释，很有耐心。语言学家管这种人叫<strong>“有同情心的对话人”（sympathetic speaker）</strong>。成年人就很难找到这么好的对话人，所以儿童学得快。</li>
      <li>第三、儿童有很多机会和对话人<strong>“商讨语言的意思”（negotiate meaning）</strong>。对于一个小孩来说，问“是什么”、“为什么”，试探性地使用语言并获得反馈太正常了，大人也很鼓励。成年人就没那么多机会，也不好意思，怕丢人。所以小孩理解得好学得快。</li>
    </ul>
  </p>

  <p>
    总结一下，对于儿童来说，<strong>学习的台阶越小越高效，越大越低效</strong>。成人帮助下的可理解性输入缩小了台阶，使儿童取得了进步。对于我们家长来说，从这些儿童学习特点能获得什么启发呢？我认为，就是要永远追求99%的理解率。我们知道，在分级阅读中有“五个手指法则”—— 一页书中如果有五个词不会读，竖起了5个手指，那么这本书就超出了孩子的能力，不合适，换另一本。如果没有不认识的词，也不好，太容易，没台阶，孩子不会进步。这是独立阅读、自主阅读里的法则
  </p>

  <p>
    当孩子独立看视频、听音频的时候，如果有99%的理解率，即100个词中只有1个词不会，那么孩子可以从上下文的情节中推论出这个词的含义。我们大人都做过英语的阅读理解题，我们知道，已知的东西越多，背景知识越强大，就越能准确地推论出不会的个别词的意思。所以，当孩子独立面对英语时，我们要追求尽量高的可理解率
  </p>

  <p>
    如果达不到95%以上的理解率，家长就要参与了，解释词汇，回答问题，讨论故事，帮助孩子理解。事实上，越是启蒙初期，孩子越需要帮助。<strong>孩子最需要家长扶上一把的有两个时期：一是听力启蒙初期，即刚开始学英语的时候，家长需要帮助孩子获得几百词到一千词的听力词汇量；二是阅读启蒙初期，学自然拼读的时候，家长要聆听孩子朗读自然拼读专项训练读物</strong>。这两个时期，需要家长扶上马走一程，但很快，孩子就会绝尘而去，听或读都用不着家长管了，家长只需做资源的提供者。这时，如果您能循序渐进地提供资源，保证孩子的可理解率，那么，孩子可以自学词汇和表达式，他们的进步是会让您惊叹的。
  </p>

  <!-- <p style="text-align:center; color: red;">&nbsp;*****</p> -->
  <section class="" data-tools="135编辑器" data-id="91660" style="font-size: 16px;border-width: 0px;border-style: none;border-color: initial;box-sizing: border-box;" data-color="rgb(255, 232, 0)">
    <section data-role="paragraph" class="" style="border-width: 0px;border-style: none;border-color: initial;box-sizing: border-box;" data-color="rgb(255, 232, 0)">
      <section style="padding: 10px;box-sizing: border-box;">
        <section style="width: 100%;" data-width="100%">
          <section style="width: 36px;height: 36px;margin-right: auto;margin-left: auto;background-color: rgb(107, 107, 107);border-width: 1px;border-style: solid;border-color: transparent;box-sizing: border-box;">
            <section style="width: 0px;height: 0px;border-width: 5px 4px;border-style: solid;border-color: transparent transparent rgb(107, 107, 107) rgb(107, 107, 107);float: right;margin-right: -8px;margin-top: -2px;box-sizing: border-box;"></section>
            <section style="width: 36px;height: 36px;border-width: 2px;border-style: solid;border-color: rgb(107, 107, 107);background-color: rgb(255, 232, 0);margin-top: 8px;margin-left: 8px;text-align: center;font-size: 20px;color: rgb(255, 255, 255);font-weight: 600;line-height: 36px;overflow: hidden;box-sizing: border-box;">
              <p class="" data-brushtype="text" data-original-title="" title=""></p>
            </section>
            <section style="width: 0px;height: 0px;border-width: 5px;border-style: solid;border-color: rgb(107, 107, 107) rgb(107, 107, 107) transparent transparent;margin-top: -10px;margin-left: -1px;box-sizing: border-box;"></section>
          </section>
        </section>
      </section>
    </section>
  </section>
  <h3 style="text-align:center">No3 什么启蒙方式最有效？</h3>

  <p>
    根据一个研究，对于0-4岁儿童的语言习得，家长和孩子对话的作用，是家长干读绘本作用的6倍。如果我们给英语启蒙方式按有效性排个序的话，那么第一名就是交流互动 （communication & interaction）。即“你一句，我一句”的对话。这意味着什么呢？意味着在家庭英语启蒙中，所有的输入方式都要向交流互动努力。
    <ul>
      <li>家长能说英语的，就在生活的真实语境下说</li>
      <li>在看视频时，要陪看要解释，看后要评论、表演、应用</li>
      <li>在亲子阅读时，要解释、要交流、要评论、读后要把能记住的单词和句型在生活中应用一下，不要只当人肉复读机</li>
      <li>听歌曲时，要解释，要和孩子一起唱一起跳、一起游戏</li>
    </ul>
    要互动、要对话，在什么情况下是互动和对话是最高效的呢？
    <ul>
      <li>场景：这里、此时，也就是<strong>here & now的输入最有效</strong>,对孩子所进行的事情进行实况转播是的评论</li>
      <li>心理：<strong>过程越愉快越无压力，输入越有效</strong>。低压力是儿童习得语言快的原因之一</li>
      <li>难度：<strong>语言在类似情境下重复率越高越有效</strong>，立体化的资源，保证同一词汇、句型在多个场景中出现，吸收才能更有效</li>
      <li>兴趣：<strong>材料越满足儿童的兴趣与求知欲越有效</strong>，语言与认知同步发展，是儿童的习得优势，他们不觉得自己在学语言；看视频、听音频和亲子阅读都顺着孩子的兴趣点，数量孩子来决定</li>
    </ul>
  </p>

  <p>
    为何需要在此时此景才算有效呢，小孩只关心此时此刻发生在眼前手里的事情。根据这一特点，家长可以对孩子所进行的事情进行实况转播式的评论（ongoing commentary）。比如说，孩子在玩积木，你就可以说：“You are putting a red block on a blue block. It looks great! Red, blue. Are you building a bridge? 你在搭桥吗？Ah, you are, you are building a bridge.” 在孩子玩的时候，不断报道他正在干什么，指着实物教一些颜色词、名词。这种here
    and now情境下的输入，孩子立刻就明白了，效果非常好。</p>
  <p>
    同时，我们也需要在多种场景中来复现，从重复这个角度来说，每天都会重复的日常活动（routine）是最适合输入的时候。比如，吃饭、睡觉、刷牙等等。对于3岁以后开始的启蒙，家长一定要在家兴致勃勃地说英语。不用担心自己语音不好，只要保证音视频的输入大于您的输入，孩子就不会受您口音的影响。而且，在为孩子打下最初的几百词之后，您就可以歇歇了，有了几百词，能理解的音视频的量还是很大的。家长也不用担心自己会说的句子太少，在最初阶段，蹦单词就可以。蹦单词您总会吧？先把人人都会的Good
    night，thank you在情境里教了，再教能指着说的名词，家里的电视呀、桌子呀、沙发呀、水果呀，想起来就指着东西说说单词。别小看这些单词，省了您的大钱了。您知道吗？这些东西如果去英语培训班，一个学期也只能教授100-200个词汇，且孩子学得可能有压力，还没办法很好的吸收，未来可能出现负迁移问题。
  </p>

  <p>
    孩子生来就是让父母成长的，因此希望我们的父母能够把肩膀垫高，给孩子最好的起跑线，以下几点是教研的老师多年积累的经验，我们公众号也会在后期继续跟进：
    <ul>
      <li>贯彻可理解性输入，听读材料都查好级别，循序渐进地推荐</li>
      <li>保证所有的材料都是立体化</li>
      <li>听力领先，以听力带动阅读，实现阅读飞跃，大量泛听，少量阅读</li>
      <li>低龄时在外教班练口语，高年级在中教班学语法</li>
      <li>积极参加词汇量测试、参加社会化考试或者一些机构的水平测试，了解孩子的最近发展区</li>
    </ul>
    最终希望我们的父母能分清什么是科研结论，什么是一家之言，什么是普适，什么是个例。崇尚科学，一家之言批判性地听；参考个例，但不要全盘模仿。因材施教是最高级的教学法，懂教学的家长是孩子的福气。希望父母都能做到<strong>心中有目标，脑中有理论，手中有资源，脚下有路线</strong>，当然可以一直关注我们的”猩语心愿“计划，那么路线、资源、理论和目标都有啦！
  </p>

  <p><span>&nbsp;</span></p>
  <p style="text-indent: 2px;">本文根据<strong>@盖兆泉 </strong><a href="http://www.360doc.com/content/16/0330/10/1354959_546476211.shtml">别在瞎磨耳朵 </a> 文章改编
    <br>
    <span style="color:#3f3f3f;font-size: 12px;color: #888888;">------------------------------------------------------------------------</span>
    <blockquote>盖兆泉，直言的学究，敢于踢馆的英语启蒙专家，毕业于北京外国语大学英语系，外研社高级编辑，曾出版《做孩子最好的英语学习规划师》。曾主持多套英语教材和读物的编写和出版，熟悉几乎所有英语教学法，各种教学理论、教材和分级读物、熟悉中小学英语教学现状和英语培训市场</blockquote>
  </p>
  <br>
</div>
</template>

<script>
export default {
  name: 'ParentRead1',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {
  color: #555;
  margin-left: auto;
  margin-right: auto;
  line-height: 20px;
  font-size: 14px;
  font-family: 微软雅黑, sans-serif;
  text-indent: 28px;
  line-height: 1.6
}

li {
  text-indent: 2px;
}

h2 {font-size: 16pt}

blockquote {
  text-indent: 1px;
  color: silver;
}

strong {
  color: rgb(0, 180, 238);
}

@media screen and (max-width: 3600px) {
  body {
    width: 550px;
  }
}

img {
  max-width: 100%;
}

@media screen and (max-width: 500px) {
  body {
    width: 98%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parentread/UnderstandValid1.vue